import { useCallback, useEffect, useState } from "react";
import { Search } from "react-bootstrap-table2-toolkit";
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Chip,
  Container,
  Card,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  Button,
} from "@material-ui/core";

// @material-ui/icons components
import { SwapHoriz } from "@material-ui/icons";

// @material-ui/lab components
import { Skeleton } from "@material-ui/lab";
// core components
import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { DialogChangeUser } from "components/Dialogs/DialogChangeUser";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";
import Api from "lib/api/httpRequestHelper";
import { IsMobile } from "utils/is-mobile";

const getTableColumns = (setSelectedUser, toggleFormDialog, searching) => [
  {
    dataField: "Nome",
    text: "Nome",
    sort: true,
    formatter: (data) => (searching ? <Skeleton variant="text" /> : data),
  },
  {
    dataField: "Login",
    text: "Login",
    sort: true,
    formatter: (data) => (searching ? <Skeleton variant="text" /> : data),
  },
  {
    dataField: "Perfis",
    text: "Perfis",
    hidden: true,
  },
  {
    dataField: "UsuarioPerfis",
    text: "Perfis",
    sort: false,
    formatter: (profiles) => {
      const profilesList = [];
      profiles?.map((profile) => {
        profilesList.push(profile?.Nome);
      });
      return searching ? (
        <Skeleton variant="text" />
      ) : (
        <>
          {profilesList?.map((profile) => (
            <Chip
              key={profile}
              style={{
                color: profile === "ADM" ? "white" : "#3f3f3f",
                border: "1px solid #3f3f3f",
                backgroundColor: profile === "ADM" ? "#3f3f3f" : "white",
                margin: "1px 1px",
                padding: "0.25rem 0.5rem",
                fontSize: "11px",
              }}
              variant="outlined"
              label={profile}
              size="small"
            />
          ))}
        </>
      );
    },
  },
  {
    dataField: "selecionar",
    text: "",
    isDummyField: true,
    formatter: (cell, row) => {
      return searching ? null : (
        <Tooltip title="Alterar Usuário">
          <IconButton
            aria-label="edit"
            onClick={() => {
              setSelectedUser(row);
              toggleFormDialog("edit");
            }}
          >
            <Box
              component={SwapHoriz}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
    headerStyle: { width: 45 },
  },
];

const loadingItems = [
  { IdUsuario: "0" },
  { IdUsuario: "1" },
  { IdUsuario: "2" },
  { IdUsuario: "3" },
  { IdUsuario: "4" },
  { IdUsuario: "5" },
  { IdUsuario: "6" },
  { IdUsuario: "7" },
  { IdUsuario: "8" },
  { IdUsuario: "9" },
];

const { SearchBar } = Search;

const useStyles = makeStyles(componentStyles);

export function TrocaUsuario() {
  const classes = useStyles();
  const snackbar = useSnackbar();

  const [users, setUsers] = useState(loadingItems);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searching, setSearching] = useState(true);

  const isMobile = IsMobile();

  const toggleFormDialog = useCallback((formType) => {
    setOpenFormDialog(formType);
  }, []);

  const fetchList = async () => {
    await Api.get("list-user", "adminportal", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setUsers(Result);
          setSearching(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderClientes section="Troca de Usuário" subsection="Administração" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <ToolkitTable
                keyField="IdUsuario"
                dataTable={searching ? loadingItems : users}
                columnModel={getTableColumns(
                  setSelectedUser,
                  toggleFormDialog,
                  searching
                )}
                search
                allowEmpty
                CustomHeader={({ searchProps }) => (
                  <Grid
                    container
                    className="pl-4"
                    style={{ padding: isMobile ? "0 24px 10px" : "0 24px" }}
                  >
                    <Grid item xs={isMobile ? 12 : 4}>
                      <Box
                        component={Typography}
                        variant="h2"
                        marginBottom="0!important"
                      >
                        <Box component="span">Lista de Usuários</Box>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={isMobile ? 12 : 8}
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        justifyContent: isMobile ? "flex-start" : "flex-end",
                        flexDirection: isMobile ? "column" : "row",
                      }}
                    >
                      <SearchBar
                        className="form-control"
                        placeholder="Pesquisar Usuário"
                        {...searchProps}
                        disabled={searching}
                      />
                      <Box
                        justifyContent="flex-end"
                        display="flex"
                        flexWrap="wrap"
                        style={{ marginLeft: isMobile ? 0 : 15 }}
                      >
                        <Button
                          variant="contained"
                          classes={{
                            root: classes.buttonRootWhite,
                          }}
                          onClick={() => toggleFormDialog("remove")}
                          disabled={
                            searching || !localStorage.getItem("k-user-vision")
                          }
                        >
                          <Box
                            component={SwapHoriz}
                            position="relative"
                            width="1.25rem!important"
                            height="1.25rem!important"
                          />
                          Redefinir usuário padrão
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                )}
                pagination={{
                  options: [25, 50, 100],
                  defaultOption: 25,
                }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      {Boolean(openFormDialog) && (
        <DialogChangeUser
          open
          onClose={() => {
            setOpenFormDialog(null);
            setSelectedUser(null);
          }}
          selectedUser={selectedUser}
          formType={openFormDialog}
        />
      )}
    </>
  );
}
